/**
 *
 * Asynchronously loads the component for Apa003
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
